import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main className="page page--narrow" id="main" tabIndex={-1}>
      <p className="eyebrow">Not found</p>
      <h1 className="page__title">There is nothing at this address</h1>
      <p className="lede">It may have moved, or it may not be visible to your account.</p>
      <p>
        <Link to="/" className="button button--secondary">
          Back to the report
        </Link>
      </p>
    </main>
  );
}
